export default __webpack_public_path__ + "static/media/arrowrect.8bae9e85.svg";